import { render } from "./Businesses.vue?vue&type=template&id=5f1505e7"
import script from "./Businesses.vue?vue&type=script&lang=js"
export * from "./Businesses.vue?vue&type=script&lang=js"

import "./Businesses.vue?vue&type=style&index=0&id=5f1505e7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__